/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Import_DuplicateInputs */

const en_import_duplicate = /** @type {(inputs: Import_DuplicateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Already in your recipes: ${i?.title}.`)
};

const de_import_duplicate = /** @type {(inputs: Import_DuplicateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Schon in deinen Rezepten: ${i?.title}.`)
};

/**
* | output |
* | --- |
* | "Already in your recipes: {title}." |
*
* @param {Import_DuplicateInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const import_duplicate = /** @type {((inputs: Import_DuplicateInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_DuplicateInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_import_duplicate(inputs)
	return en_import_duplicate(inputs)
});